import lottie from 'lottie-web'

const INTRO_OUT = 146
const LOOP_IN = 80
const LOOP_OUT = 145
const VIEW_BOX = '238.3 300.9 603.9 503.1'
const PATH = '/json/logo-loop.json'

export const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches

export const createPulseMark = (container, { onReady, onFail } = {}) => {

	if (!container || prefersReducedMotion()) return null

	const animation = lottie.loadAnimation({
		container: container,
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: PATH,
		rendererSettings: {
			viewBoxOnly: true,
			viewBoxSize: VIEW_BOX,
			preserveAspectRatio: 'xMidYMid meet',
		},
	})

	let settled = false

	animation.addEventListener('DOMLoaded', () => {
		container.querySelectorAll('[aria-label]').forEach(node => node.removeAttribute('aria-label'))
		if (onReady) onReady(animation)
		animation.playSegments([0, INTRO_OUT], true)
	})

	animation.addEventListener('complete', () => {
		if (settled) return
		settled = true
		animation.loop = true
		animation.playSegments([LOOP_IN, LOOP_OUT], true)
	})

	animation.addEventListener('data_failed', () => {
		animation.destroy()
		if (onFail) onFail()
	})

	return animation
}

export default () => { }
